import { Component } from '@angular/core';

/**
 * Transient view shown on /login/callback while AuthService.initialize()
 * exchanges the Okta authorization code and loads the user. App navigates
 * away (to /requests or /unauthorized) as soon as that resolves.
 */
@Component({
  selector: 'app-callback',
  standalone: true,
  template: `
    <div class="callback">
      <p>Signing you in&hellip;</p>
    </div>
  `,
  styles: `
    .callback {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
    }
  `,
})
export class Callback {}
